<template>
  <div class="topic-manage">
    <div class="topic-manage-header">
      <div><span @click="$emit('back')" style="cursor: pointer;">我的专题</span>>编辑专题</div>
    </div>
    <div class="paper-list-content">
      <div class="top-setting flex">
        <div class="top-setting-box">
          <div class="setting-label">专题名称</div>
          <el-input v-model="name" :maxlength="20" placeholder="请输入20字以内的文本信息" class="mb10"></el-input>
          <div class="setting-label">微信摘要设置</div>
          <el-input v-model="description" type="textarea" resize="none" :maxlength="100" placeholder="请输入50字以内文本信息"> </el-input>
        </div>
        <div class="top-setting-box thumbnail">
          <div class="setting-label">微信链接封面</div>
          <input type="file" id="input-upload-thumbnail" ref="uploadThum" accept="image/png, image/jpeg, image/gif, image/jpg" @change="thumbUploadImg($event)" style="display:none" />
          <label for="input-upload-thumbnail">
            <template v-if="thumbnail">
              <img :src="thumbnail" alt="" />
            </template>
            <template v-if="!thumbnail">
              <img src="@imgs/paper/thumb_default_300.png" alt="" />
            </template>
            <div class="upload-text">上传链接封面</div>
          </label>
          <CropDialog ref="crop" :cropImgUrl="thumbnailCropImgUrl" @cropConfirm="thumbCropConfirm"></CropDialog>
        </div>
        <div class="top-setting-box head-image">
          <div>
            <div class="setting-label">专题页头图</div>
            <el-select size="mini" v-model="headImageSwitch" class="head-image-switch">
              <el-option label="开启" :value="1" />
              <el-option label="不开启" :value="0" />
            </el-select>
          </div>
          <div v-if="headImageSwitch">
            <input type="file" id="input_upload_head" ref="uploadHead" accept="image/png, image/jpeg, image/gif, image/jpg" @change="headUploadImg($event)" style="display:none" />
            <label for="input_upload_head">
              <template v-if="headImage">
                <img :src="headImage" alt="" />
              </template>
              <template v-if="!headImage">
                <img src="@imgs/paper/thumb_default_640.png" alt="" />
              </template>
              <div class="upload-text">上传头图</div>
            </label>
            <!-- <CropDialog ref="headCrop" :cropImgUrl="headCropImgUrl" @cropConfirm="headCropConfirm"></CropDialog> -->
          </div>
        </div>
      </div>
      <div class="table-about">
        <div class="table-about-left" @click="toAddArticle">添加文章</div>
        <div class="table-about-right">
          <span>排序：</span>
          <span class="sort-types">
            <span class="sort-item" @click="sortNormalList('title', true)">按文章名称正序</span>
            <span class="sort-item" @click="sortNormalList('title', false)">按文章名称倒序</span>
            <span class="sort-item" @click="sortNormalList('publishDate', true)">按报纸刊期正序</span>
            <span class="sort-item" @click="sortNormalList('publishDate', false)">按报纸刊期倒序</span>
          </span>
        </div>
      </div>
      <el-table :data="currentPageList" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
        <el-table-column prop="title" label="文章名称" min-width="200"> </el-table-column>
        <el-table-column prop="baoZhiName" label="来源数字报" min-width="50"> </el-table-column>
        <el-table-column prop="publishDateFormat" label="报纸刊期" min-width="100"> </el-table-column>
        <el-table-column label="操作" min-width="150">
          <template slot-scope="scope">
            <div class="operate">
              <div class="option-button button1" title="查看" @click="viewItem(scope.row)"></div>
              <div class="option-button button2" title="置顶锁定" @click="lockItem(scope.row)" v-show="!isInLockList(scope.$index)"></div>
              <div class="option-button button8" title="置顶解锁" @click="cancelLockItem(scope.row)" v-show="isInLockList(scope.$index)"></div>
              <div class="option-button button3" title="置顶" @click="topItem(scope.row, scope.$index)"></div>
              <div class="option-button button4" title="上移" @click="upItem(scope.row, scope.$index)"></div>
              <div class="option-button button5" title="下移" @click="downItem(scope.row, scope.$index)"></div>
              <div class="option-button button6" title="置底" @click="bottomItem(scope.row)"></div>
              <div class="option-button button7" title="删除" @click="delItem(scope.row, scope.$index)"></div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex flex-between pages">
        <div class="page-counts">
          共 <span>{{ tableData.length }}</span> 条记录
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :total="tableData.length"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          :layout="'prev, pager, next'"
        />
      </div>
    </div>
    <div class="topic-manage-footer">
      <el-divider></el-divider>
      <div class="buttons">
        <div class="button left" @click="saveThen()">保存</div>
        <div class="button right" @click="saveThen(true)">保存并返回列表</div>
      </div>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <AddArticleDialog ref="addArticleDialog" @addArticle="addArticle" :checkedListIds="tableDataIds" />
    <div class="digital-loading" v-if="dataLoading">
      <div class="text">加载中...</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ListFrame from '@components/list/listFrame'
import AddArticleDialog from './AddArticleDialog.vue'
import api from '@api/paperManager'
import compareVipRight from '@components/common/compareVipRight.js'
import TipDialog from '@components/common/TipDialog.vue'
import moment from 'moment'
import CropDialog from '@components/editDrawer/edit/CropDialog.vue'
import { sliceStrPicUrl, base64ToFile } from '@/utils'
import setBook from '@api/setBook'
export default {
  name: 'myTopics',
  mixins: [compareVipRight],
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      paperList: [],
      baozhiName: '',
      queryName: '',
      fromDate: '',
      toDate: '',
      isInset: true, //是否显示分享书刊嵌入代码
      typeName: 'paper',
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0,
        title: ''
      },
      id: 8,
      name: '',
      thumbnail: '',
      owner: '',
      description: '',
      headImageSwitch: 0,
      headImage: '',
      tops: '',
      articleIds: '',
      thumbnailCropImgUrl: '',
      headCropImgUrl: '',
      dialogVisible: true,
      pageSize: 10,
      currentPage: 1,
      normalList: [],
      lockList: [],
      dataLoading: true
    }
  },
  props: ['topicObj'],
  components: { AddArticleDialog, TipDialog, CropDialog },
  computed: {
    tableDataIds() {
      return this.tableData.map((item) => item.id).join(',')
    },
    tableData() {
      return this.lockList.concat(this.normalList)
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    currentPageList() {
      console.log(66)
      return this.tableData.slice(10 * (this.currentPage - 1), this.currentPage * 10)
    },
    userName() {
      return localStorage.getItem('username')
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  watch: {
    queryName() {
      this.searched = false
    }
  },

  methods: {
    sortNormalList(key, asc) {
      if (key === 'title') {
        this.normalList.sort(function(item1, item2) {
          if (asc) {
            return item1[key].localeCompare(item2[key], 'zh-CN')
          } else {
            return item2[key].localeCompare(item1[key], 'zh-CN')
          }
        })
      } else {
        this.normalList.sort(function(item1, item2) {
          if (asc) {
            return item1[key] - item2[key]
          } else {
            return item2[key] - item1[key]
          }
        })
      }
    },
    isInLockList(index) {
      return index + this.pageSize * (this.currentPage - 1) < this.lockList.length
    },
    delItem(item) {
      let res = this.getArrAndIndex(item)
      if (res) {
        res.arr.splice(res.index, 1)
      }
    },
    //根据item查找当前item是在lockList里还是lockList里，并返回对应的arr,index
    getArrAndIndex(item) {
      let res
      let lockIndex = this.lockList.findIndex((lockItem) => lockItem.id === item.id)
      if (lockIndex > -1) {
        res = {
          index: lockIndex,
          arr: this.lockList
        }
      } else {
        res = {
          index: this.normalList.findIndex((lockItem) => lockItem.id === item.id),
          arr: this.normalList
        }
      }
      return res
    },
    lockItem(item) {
      let { arr, index } = this.getArrAndIndex(item)
      let delItem = arr.splice(index, 1)[0]
      this.lockList.push(delItem)
    },
    cancelLockItem(item) {
      let { arr, index } = this.getArrAndIndex(item)
      let delItem = arr.splice(index, 1)[0]
      this.normalList.unshift(delItem)
    },
    topItem(item) {
      let { arr, index } = this.getArrAndIndex(item)
      let delItem = arr.splice(index, 1)[0]
      arr.unshift(delItem)
    },
    bottomItem(item) {
      let { arr, index } = this.getArrAndIndex(item)
      let delItem = arr.splice(index, 1)[0]
      arr.push(delItem)
    },
    upItem(item) {
      let { arr, index } = this.getArrAndIndex(item)
      if (index === 0) {
        this.$message({
          type: 'error',
          message: '第一条数据, 不能上移'
        })
      } else {
        this.swapElements(arr, index - 1, index)
      }
    },
    downItem(item) {
      console.log(item)
      let { arr, index } = this.getArrAndIndex(item)
      if (index === arr.length - 1) {
        this.$message({
          type: 'error',
          message: (arr === this.lockList ? '置顶锁定中' : '') + '最后一条数据, 不能下移'
        })
      } else {
        this.swapElements(arr, index + 1, index)
      }
    },
    swapElements(arr, indexA, indexB) {
      const temp = arr[indexA]
      arr.splice(indexA, 1, arr[indexB])
      arr.splice(indexB, 1, temp)
    },
    viewItem(item) {
      let path = '/digitalArticle'
      let routeUrl = this.$router.resolve({
        path: path,
        query: { id: item.id }
      })
      window.open(routeUrl.href, '_blank')
    },
    addArticle(row) {
      this.normalList.push(row)
    },
    handleCurrentChange() {},
    handleSizeChange() {},
    toAddArticle() {
      this.$refs.addArticleDialog.dialogVisible = true
    },
    async picChangeUrl(payload, data) {
      const result = await this.uploadImage(payload, data)
      if (result && result.data.code === 0) {
        return result.data.data
      }
    },
    async uploadImage(payload, data) {
      let params = new FormData()
      let waitData = null
      if (payload !== 'background') {
        waitData = base64ToFile(data) || ''
      } else {
        waitData = data
      }
      params.append('fieldName', payload)
      params.append(payload, waitData)
      return setBook.uploadPicture(params)
    },
    editTopic(params, isBack) {
      this.dataLoading = true
      api.editTopic(params).then((res) => {
        this.dataLoading = false
        if (res.data.status === 0) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          setTimeout(() => {
            if (isBack) {
              this.$emit('back')
            }
          }, 1000)
        } else {
          this.$message({
            message: res.data.message || '保存失败',
            type: 'error'
          })
        }
      })
    },
    thumbUploadImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      _this.fileName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        _this.thumbnailCropImgUrl = res.target.result
        _this.thumbnail = res.target.result
        _this.$refs.uploadThum.value = ''
        _this.$refs.crop.dialogVisible = true
        _this.$nextTick(() => {
          _this.$refs.crop.init()
        })
      }
    },
    headUploadImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      _this.fileName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        _this.headCropImgUrl = res.target.result
        _this.headImage = res.target.result
        // _this.$refs.uploadHead.value = ''
        // _this.$refs.headCrop.dialogVisible = true
        // _this.$nextTick(() => {
        //   _this.$refs.headCrop.init()
        // })
      }
    },
    thumbCropConfirm(file) {
      this.thumbnail = file
    },
    headCropConfirm(file) {
      this.headImage = file
    },

    async saveThen(isBack) {
      let thumbnail = this.thumbnail
      let headImage = this.headImage
      if (thumbnail && thumbnail.includes('data:image')) {
        thumbnail = await this.picChangeUrl('topicThumbnail', thumbnail)
      } else {
        thumbnail = thumbnail ? sliceStrPicUrl(thumbnail) : ''
      }
      if (headImage && headImage.includes('data:image')) {
        headImage = await this.picChangeUrl('topicHeadImage', headImage)
      } else {
        headImage = headImage ? sliceStrPicUrl(headImage) : ''
      }
      this.editTopic(
        {
          id: this.topicObj.id,
          name: this.name,
          thumbnail,
          description: this.description,
          headImageSwitch: this.headImageSwitch,
          headImage,
          tops: this.lockList.map((item) => item.id).join(','),
          articleIds: this.tableData.map((item) => item.id).join(','),
          owner: this.userName
        },
        isBack
      )
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    },
    setTopicDetailData(data) {
      this.name = data.name
      this.thumbnail = data.thumbnail
      this.owner = data.owner
      this.description = data.description
      this.headImageSwitch = data.headImageSwitch
      this.headImage = data.headImage
      this.tops = data.tops
      this.articleIds = data.articleIds
    },
    getTopicById() {
      const param = {
        id: this.topicObj.id
      }
      api.getTopicById(param).then((res) => {
        this.dataLoading = false
        if (res.status === 200 && res.data.status === 0) {
          let data = res.data.data
          data.articleList.forEach((item) => {
            item.publishDateFormat = item.publishDate ? moment(item.publishDate).format('YYYY-MM-DD') : ''
            if (data.tops && data.tops.includes(item.id + '')) {
              this.lockList.push(item)
            } else {
              this.normalList.push(item)
            }
          })
          this.setTopicDetailData(data)
        }
      })
    }
  },
  created() {
    console.log('created')
    this.getTopicById()
  }
}
</script>
<style lang="scss" scoped>
.topic-manage {
  height: 100%;
  overflow: auto;
  .paper-list-content {
    overflow: hidden;
    /deep/ .el-pagination {
      margin: 10px;
    }
  }
  padding-left: 18px;
  .topic-manage-header {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
  }
  .topicForm {
    padding-top: 30px;
  }
  .operate {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .option-button {
    height: 25px;
    width: 19px;
    background: url('~@imgs/bookshelfedit/icon_view.png') no-repeat center center/cover;
    margin: 0 10px;
    cursor: pointer;
  }
  .button1,
  .button2,
  .button7,
  .button8 {
    width: 25px;
  }
  .button1 {
    background-image: url('~@imgs/bookshelfedit/icon_view.png');
  }
  .button2 {
    background-image: url('~@imgs/bookshelfedit/move_top_lock.png');
  }
  .button3 {
    background-image: url('~@imgs/bookshelfedit/MoveTop@2x.png');
  }
  .button4 {
    background-image: url('~@imgs/bookshelfedit/icon_up.png');
  }
  .button5 {
    background-image: url('~@imgs/bookshelfedit/icon_down.png');
  }
  .button6 {
    background-image: url('~@imgs/bookshelfedit/MoveBottom@2x.png');
  }
  .button7 {
    background-image: url('~@imgs/bookshelfedit/delete.png');
  }
  .button8 {
    background-image: url('~@imgs/bookshelfedit/move_top_unlock.png');
  }
  .table-about {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    &-left {
      width: 105px;
      line-height: 35px;
      border-radius: 8px;
      background: rgba(223, 88, 19, 1);
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
    &-right {
      .sort-types {
        color: rgba(223, 88, 19, 1);
        .sort-item {
          cursor: pointer;
          margin-right: 15px;
        }
      }
    }
  }
  .topic-manage-footer {
    /deep/ .el-divider {
      margin: 0;
    }
    .buttons {
      display: flex;
      justify-content: center;
      margin: 10px 0;

      .button {
        margin: 0 50px;
        width: 200px;
        line-height: 54px;
        border: 1px solid rgba(223, 88, 19, 1);
        text-align: center;
        font-size: 20px;
        cursor: pointer;
      }
      .left {
        background: rgba(223, 88, 19, 1);
        color: #fff;
      }
      .right {
        border-color: rgba(223, 88, 19, 1);
        color: rgba(223, 88, 19, 1);
      }
    }
  }
  /deep/ .common-list-wrapper .common-list {
    height: calc(100vh - 360px);
  }
  /deep/ .el-pagination {
    float: none;
  }
  .pages {
    align-items: center;
  }
  .page-counts {
    background-color: #fff;
    text-align: center;
    span {
      color: #df5813;
    }
  }
  .top-setting-box {
    margin-right: 20px;
    .setting-label {
      // font-size: 20px;
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .setting-label:first-of-type {
      margin-top: 0;
    }
    img {
      display: block;
      width: 100%;
      cursor: pointer;
    }
    &.thumbnail {
      width: 180px;
    }
    &.head-image {
      width: 300px;
    }
    .head-image-switch {
      margin-bottom: 10px;
    }
    .upload-text {
      line-height: 30px;
      background: rgba(223, 88, 19, 1);
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
